import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default ({ children }: React.PropsWithChildren) => (
    <article className="task-manager-item__skeleton sgw-link-card align-center no-icon with-notification">
        <div className="sgw-link-card__link">
            <span className="sgw-link-card__content-wrapper">
                <Skeleton className="sgw-link-card-title title" height={28} width={150} />
            </span>
        </div>
        {children && <div className="sgw-link-card__content-container">{children}</div>}
    </article>
);
